import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/inventorySlice";
import inventoryTransactionApis from "src/api/inventoryTransaction";
import adjustmentOrderApis from "src/api/adjustmentOrder";
import { constants } from "src/constants/common";
import { common } from "src/types";

function* GetTransactionListSaga({
  payload,
}: ReturnType<typeof actions.getTransactionListRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      inventoryTransactionApis.list,
      payload
    );
    yield put(actions.getTransactionListSuccess(response));
  } catch (error) {
    yield put(
      actions.getTransactionListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* CreateAdjustmentSaga({
  payload,
}: ReturnType<typeof actions.createAdjustmentRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      adjustmentOrderApis.create,
      payload
    );
    yield put(actions.createAdjustmentSuccess(response));
  } catch (error) {
    yield put(
      actions.createAdjustmentError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* inventorySaga() {
  yield all([
    takeEvery(actions.getTransactionListRequest, GetTransactionListSaga),
    takeEvery(actions.createAdjustmentRequest, CreateAdjustmentSaga),
  ]);
}
